import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import getFilesSFTP, { listFilesSFTP, getSelectedFilesSFTP } from '../../api/getFilesSFTP'
import { TableList } from '../../components/TableList'
import { deleteFileByDirectory } from '../../functions/deleteFile'
import format from 'dateformat'
import SettingsDirectory from '../interface/settingsDirectory'
import globalNotification from 'live/services/global-notification'

export default function Container({ qualifier, alwaysDeleteFile }) {
    const offset = 50
    const [files, setFiles] = useState([])
    const [filesUids, setFilesUids] = useState<string[]>([])
    const [filesShowing, setFilesFilesShowing] = useState<number>(offset)

    const [info, setInfo] = useState<SettingsDirectory>({
        config: {
            lastEvent: 0,
            startCollection: 0
        },
        fullName: '',
        name: '',
        type: ''
    })

    const [reprocessFiles, setReprocessFile] = useState<number>(undefined)

    useEffect(() => {
        // updateFiles()
        listFilesSFTP(qualifier).then(Allfiles => {
            setFilesUids(Allfiles)
        })
        getInfo().then(newInfo => setInfo(newInfo))
    }, [qualifier])

    useEffect(() => {
        updateFiles()
    }, [filesUids,filesShowing])

    const updateFiles = () => {        
        if (filesShowing > files.length && filesUids.length > 0) {
            
            const selectedFiles = []
            
            for (let i = files.length; i < filesShowing; i++) {            
                const selectedUID = filesUids[i]
                if (!!selectedUID) {
                    selectedFiles.push(selectedUID)
                }
            }
            getSelectedFilesSFTP(qualifier, selectedFiles).then(newFiles => {
                setFiles(currentFiles => [...currentFiles, ...newFiles])
            })
        }
    }

    const getInfo = async () => {
        const result = await fetch(`/services/plugin-upload/settings-directory/upload-sftp/${qualifier}`, {
            credentials: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'X-Forwarded-Proto': 'https'
            }
        })
        return result.json()
    }

    const apiReprocessFiles = async () => {
        fetch(`/services/plugin-upload/reprocess/upload-sftp/${qualifier}/${reprocessFiles}`, {
            credentials: 'same-origin',
            cache: 'no-cache',
            method: 'PUT'
        })
            .then(response => response.json())
            .then(newsInfo => {
                globalNotification.success(
                    `Successfully. In the next operation was to capture the fiels since ${format(
                        new Date(Number(reprocessFiles)),
                        'dd/mm/yyyy'
                    )}`
                )

                setInfo(newsInfo)
            })
            .catch(error => {
                globalNotification.error(`Error: Unable to reset collection date`)
                setReprocessFile(undefined)
            })
    }

    const lastEvent = info?.config?.lastEvent
    const startCollection = info?.config?.startCollection

    return (
        <div>
            <Header>
                <HeaderContent>
                    <Title>Last file collected:</Title>{' '}
                    <label style={{ display: 'inline' }}>
                        {!lastEvent ? '--|--' : format(new Date(Number(lastEvent)), 'dd/mm/yyyy HH:MM:ss')}
                    </label>
                </HeaderContent>

                <HeaderContent>
                    <Title style={{ display: 'inline' }}>Reprocess files since the date :</Title>
                    <div>
                        <input
                            type={'date'}
                            disabled={alwaysDeleteFile}
                            value={format(
                                new Date(Number(reprocessFiles > 0 ? reprocessFiles : new Date().getTime())),
                                'yyyy-mm-dd'
                            )}
                            style={{ display: 'inline', padding: '5px' }}
                            onChange={({ target }) => {
                                setReprocessFile(new Date(target?.value).getTime())
                            }}
                        ></input>
                        <button
                            className="btn btn-primary"
                            disabled={alwaysDeleteFile || !reprocessFiles}
                            onClick={() => {
                                if (reprocessFiles != startCollection) {
                                    apiReprocessFiles()
                                }
                            }}
                            style={{ display: 'inline', padding: '5px', marginLeft: '10px' }}
                        >
                            Apply reset date
                        </button>
                    </div>
                </HeaderContent>
            </Header>
            <TableList
                files={files}
                setFiles={updateFiles}
                directory={`upload-sftp/${qualifier}`}
                deleteFileByUid={deleteFileByDirectory}
                offset={offset}
                totalFiles={filesUids.length}
                loadMore={true}
                fcLoadFiles={() => {
                    setFilesFilesShowing(cur => cur + offset)
                }}
            />
        </div>
    )
}

const Header = styled.div`
    display: flex;
    background-color: white;
    padding: 5px 5px;    
    min-height: 80px;
`
const HeaderContent = styled.div`
    padding: 10px;
    height: 50px;
`
const Title = styled.span`
    padding: 10px 0px;
`
